import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const Wrapper = styled(Flex)<{
  $textColor?: string | null;
}>`
  ${({ $textColor, theme }) => css`
    gap: ${theme.spacing(1.25)};
    height: ${theme.spacing(9.75)};
    margin: ${theme.spacing(2, 0, 0, 0)};
    justify-content: center;
    ${theme.media.md.up} {
      gap: ${theme.spacing(3)};
      height: ${theme.spacing(15)};
      margin: ${theme.spacing(3, 0, 0, 0)};
    }
    color: ${$textColor ?? theme.colors.default};
  `}
`;
export const NumberWrapper = styled(Flex)`
  position: relative;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: 1rem;
    ${theme.media.md.up} {
      font-size: 1.25rem;
    }
  `}
  flex-flow: column;
  align-items: center;
`;
export const Number = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.semibold};
    font-size: 4.25rem;
    @media (max-width: 375px) {
      font-size: 4rem;
    }
    ${theme.media.md.up} {
      font-size: 7.5rem;
    }
  `}
  display: inline;
  white-space: nowrap;
`;
export const Label = styled(Box)`
  ${({ theme }) => css`
    text-transform: uppercase;
    font-weight: ${theme.fontWeights.regular};
  `}
  position: absolute;
  bottom: 0;
  white-space: nowrap;
`;

export const Separator = styled(Box)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.semibold};
    font-size: 3rem;
    line-height: 3.5rem;
    ${theme.media.md.up} {
      font-size: 5rem;
      line-height: 6rem;
    }
  `}
`;
